"use strict";

var _classCallCheck = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/createClass.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactifySearchLiquidFactory = void 0;

var react_1 = __importDefault(require("react"));

var components_1 = require("../components");

var ReactifySearchLiquidFactory = /*#__PURE__*/function () {
  function ReactifySearchLiquidFactory(providerProps) {
    _classCallCheck(this, ReactifySearchLiquidFactory);

    this.providerProps = providerProps;
  }

  _createClass(ReactifySearchLiquidFactory, [{
    key: "getProvider",
    value: function getProvider() {
      var _this = this;

      var _a, _b, _c, _d, _e;

      var shopifyPermanentDomain = (_a = this.providerProps.shopifyPermanentDomain) !== null && _a !== void 0 ? _a : (_c = (_b = window) === null || _b === void 0 ? void 0 : _b.Shopify) === null || _c === void 0 ? void 0 : _c.shop;

      if (!shopifyPermanentDomain) {
        throw new Error("Cannot determine shopifyPermanentDomain from window");
      }

      var collectionHandle = (_d = this.providerProps.collectionHandle) !== null && _d !== void 0 ? _d : (_e = window.location.pathname.split("/")) === null || _e === void 0 ? void 0 : _e[2];

      if (this.providerProps.mode === "collection" && !collectionHandle) {
        throw new Error("Cannot determine collectionHandle from URL");
      }

      var provider = function provider(props) {
        return react_1.default.createElement(components_1.ReactifySearchProvider, Object.assign({}, _this.providerProps, {
          shopifyPermanentDomain: shopifyPermanentDomain,
          collectionHandle: collectionHandle
        }), props.children);
      };

      return provider;
    }
  }, {
    key: "getMountNode",
    value: function getMountNode() {
      var mountNode = document.getElementById("reactify-mount-".concat(this.providerProps.mode));

      if (!mountNode) {
        throw new Error("Cannot find mount node with ID \"reactify-mount-".concat(this.providerProps.mode, "\""));
      }

      return mountNode;
    }
  }, {
    key: "getData",
    value: function getData() {
      var dataNode = document.getElementById("reactify-data");

      if (!dataNode) {
        throw new Error("Cannot find data node with ID \"reactify-data\"");
      }

      try {
        var data = JSON.parse(dataNode.innerHTML);
        return data;
      } catch (_a) {
        throw new Error("Cannot parse the data node with ID \"reactify-data\", check your liquid formatting");
      }
    }
  }]);

  return ReactifySearchLiquidFactory;
}();

exports.ReactifySearchLiquidFactory = ReactifySearchLiquidFactory;